// import React, { useState } from "react";
// import axios from "axios";
// import Navbar from "../components/Navbar";
// import './LoginPage.css';
// import { Link, useNavigate } from "react-router-dom";

// const LoginPage = () => {
//   const [otpStatus, setOtpStatus] = useState(false);
//   const [otp, setOtp] = useState("");
//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");
//   const [mobilenumber, setMobilenumber] = useState("");

//   let host = "http://13.203.79.3:3000"; // Update the host as needed
//   const navigate = useNavigate();

//   const handleLogin = async () => {
//     if (username === "" || password === "") {
//       alert("Please Enter Username and password");
//     } else {
//       try {
//         const response = await axios.post(`${host}/loginuser`, { username, password });

//         if (response.status === 200 && response.data.status === 200) {
//           const userData = {
//             username,
//             password,
//             name: response.data.data[0].name,
//           };
//           setMobilenumber(response.data.data[0].mobile_number);

//           if (response.data.data[0].user_type !== 0) { // Admin or special user type requiring OTP
//             try {
//               const otpResponse = await axios.post(`${host}/userotplogin`, {
//                 mobile_number: response.data.data[0].mobile_number,
//               });

//               if (otpResponse.data.status === 200) {
//                 setOtpStatus(true); // Show OTP input field
//                 alert("OTP sent to registered mobile number");
//               } else {
//                 alert("Failed to send OTP");
//               }
//             } catch (otpError) {
//               console.error("Error during OTP request:", otpError.message);
//             }
//           } else {
//             // Update localStorage and navigate directly if no OTP needed
//             localStorage.setItem("token-info", JSON.stringify(userData));
//             localStorage.setItem("userRole", response.data.data[0].user_type);
//             localStorage.setItem("access_token", response.data.data[0].access_token);
//             navigateUser(response.data);
//           }
//         } else {
//           alert("Invalid password or user not found");
//         }
//       } catch (error) {
//         console.error("Login failed:", error.message);
//       }
//     }
//   };

//   const handleVerifyOtp = async () => {
//     try {
//       const otpVerifyResponse = await axios.post(`${host}/userverifyotp`, {
//         username,
//         otp,
//         mobile_number: mobilenumber,
//       });

//       if (otpVerifyResponse.data.status === 200) {
//         alert("OTP Verified Successfully");

//         // Store user data and navigate after OTP verification
//         const response = await axios.post(`${host}/loginuser`, { username, password });

//         if (response.status === 200 && response.data.status === 200) {
//           const userData = {
//             username,
//             password,
//             name: response.data.data[0].name,
//           };

//           localStorage.setItem("token-info", JSON.stringify(userData));
//           localStorage.setItem("userRole", response.data.data[0].user_type);
//           localStorage.setItem("access_token", response.data.data[0].access_token);

//           navigateUser(response.data);
//         } else {
//           alert("Invalid password or user not found");
//         }
//       } else {
//         alert("Failed to verify OTP");
//       }
//     } catch (otpVerifyError) {
//       console.error("Error verifying OTP:", otpVerifyError.message);
//     }
//   };

//   const navigateUser = (userData) => {
//     let bookingDetailsData = JSON.parse(localStorage.getItem("bookingDetailsData"));

//     if (bookingDetailsData === undefined || bookingDetailsData.selectedRooms === null) {
//       navigate("/Accomodation", "_self");
//     } else {
//       navigate("/Accomodation", "_self");
//     }
//   };

//   return (
//     <div>
//       <Navbar/>
//       <div className="container">
//         <div className="row justify-content-center">
//           <div className="col-lg-10 col-md-10 col-sm-10 col-xs-10">
//             <div className="container mt-5">
//               <form className="login-form">
//                 <h1 className="text-center" style={{ fontSize: "25px", color: "green" }}>
//                   Login
//                 </h1>
//                 <div className="mb-3">
//                   <label>Username: </label>
//                   <input
//                     type="text"
//                     value={username}
//                     onChange={(e) => setUsername(e.target.value)}
//                   />
//                 </div>
//                 <br />
//                 <div className="mb-3">
//                   <label>Password: </label>
//                   <input
//                     type="password"
//                     value={password}
//                     onChange={(e) => setPassword(e.target.value)}
//                   />
//                 </div>
//                 <br />
//                 {otpStatus && (
//                   <div>
//                     <label>Enter OTP: </label>
//                     <input
//                       type="text"
//                       value={otp}
//                       onChange={(e) => setOtp(e.target.value)}
//                     />
//                   </div>
//                 )}
//                 <br />
//                 <button
//                   type="button"
//                   className="btnss btn-primarys login-button"
//                   onClick={otpStatus ? handleVerifyOtp : handleLogin}
//                 >
//                   {otpStatus ? "Verify OTP" : "Login"}
//                 </button>
//                 <div className="mt-3" style={{ fontSize: "18px" }}>
//                   Not registered? <Link to="/registration">Register now</Link>
//                   <br />
//                   <div className="mt-3" style={{ marginLeft: "20px" }}>
//                     <Link to="/forgot-password">Forgot Password?</Link>
//                   </div>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LoginPage;

// import React, { useState } from "react";
// import axios from "axios";
// import Navbar from "../components/Navbar";
// import Header from "../components/Header";
// import "./LoginPage.css";
// import { Link, useNavigate } from "react-router-dom";

// const LoginPage = () => {
//   const [otpStatus, setOtpStatus] = useState(false);
//   const [otp, setOtp] = useState("");
//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");
//   const [mobilenumber, setMobilenumber] = useState("");

//   // let host = "https://api.vmrdarental.com";
//   let host = "https://api.vmrdarental.com";

//   const navigate = useNavigate();

//   const handleLogin = async () => {
//     if (username === "" || password === "") {
//       alert("Please Enter Username and password");
//     } else {
//       try {
//         const response = await axios.post(host + "/loginuser", {
//           username,
//           password,
//         });

//         console.log("API Response:", response);
//         console.log("API Data:", response.data);

//         if (response.status === 200 && response.data.status === 200) {
//           const userData = {
//             username,
//             password,
//             name: response.data.data[0].name, // Store the user's name
//           };
//           localStorage.setItem("token-info", JSON.stringify(userData));
//           localStorage.setItem("userRole", response.data.data[0].user_type);
//           localStorage.setItem(
//             "access_token",
//             response.data.data[0].access_token
//           );
//           let bookingDetailsData = JSON.parse(
//             localStorage.getItem("selectedRoomData")
//           );

//           // If the user type is 0 (regular user), check for booking details
//           if (response.data.data[0].user_type === 0) {
//             // Check if bookingDetailsData exists and has selectedRooms
//             if (
//               !bookingDetailsData || // If bookingDetailsData is undefined
//               !bookingDetailsData.selectedRooms || // or selectedRooms is null or undefined
//               bookingDetailsData.selectedRooms.length === 0 // or selectedRooms array is empty
//             ) {
//               navigate("/", "_self");
//             } else {
//               navigate("/", "_self");
//             }
//           } else {
//             console.log("Admin OTP Required");
//             try {
//               const respOtpStatus = await axios.post(host + "/userotplogin", {
//                 mobile_number: response.data.data[0].mobile_number,
//               });
//               if (respOtpStatus.data.status === 200) {
//                 setOtpStatus(true);
//                 console.log(otpStatus, "otpStatus true");
//               }
//             } catch (error) {
//               console.error("Login failed:", error.message);
//             }
//           }
//         } else {
//           alert("Invalid password or user not found");
//         }
//         console.log("Login attempt completed");
//       } catch (error) {
//         console.error("Login failed:", error.message);
//       }
//     }
//   };

//   const handleVerifyOtp = async () => {
//     try {
//       const otpVerifyResponse = await axios.post(host + "/userverifyotp", {
//         username,
//         otp,
//         mobile_number: mobilenumber, // Adjust this accordingly based on your backend
//       });

//       if (otpVerifyResponse.data.status === 200) {
//         alert("OTP Verified Successfully");

//         // Continue with the login process
//         const response = await axios.post(host + "/loginuser", {
//           username,
//           password,
//         });

//         if (response.status === 200 && response.data.status === 200) {
//           const userData = {
//             username,
//             password,
//             name: response.data.data[0].name,
//           };

//           localStorage.setItem("token-info", JSON.stringify(userData));
//           localStorage.setItem("userRole", response.data.data[0].user_type);
//           localStorage.setItem(
//             "access_token",
//             response.data.data[0].access_token
//           );

//           let bookingDetailsData = JSON.parse(
//             localStorage.getItem("bookingDetailsData")
//           );

//           // Check if bookingDetailsData exists and has selectedRooms
//           if (
//             !bookingDetailsData || // If bookingDetailsData is undefined
//             !bookingDetailsData.selectedRooms || // or selectedRooms is null or undefined
//             bookingDetailsData.selectedRooms.length === 0 // or selectedRooms array is empty
//           ) {
//             navigate("/", "_self");
//           } else {
//             navigate("/previewpage", "_self");
//           }
//         } else {
//           alert("Invalid password or user not found");
//         }
//       } else {
//         alert("Failed to verify OTP");
//       }
//     } catch (otpVerifyError) {
//       console.error("Error verifying OTP:", otpVerifyError.message);
//     }
//   };

//   return (
//     <div>
//       <Header />

//       <div className="container">
//         <div className="row justify-content-center">
//           <div className="col-lg-10 col-md-10 col-sm-10 col-xs-10">
//             <div className="container mt-2">
//               <form className="login-form">
//                 <h1
//                   className="text-center"
//                   style={{ fontSize: "25px", color: "green" }}
//                 >
//                   Login
//                 </h1>
//                 <div className="mb-3">
//                   <label>Username: </label>
//                   <input
//                     type="text"
//                     value={username}
//                     onChange={(e) => setUsername(e.target.value)}
//                   />
//                 </div>

//                 <div className="mb-3">
//                   <label>Password: </label>
//                   <input
//                     type="password"
//                     value={password}
//                     onChange={(e) => setPassword(e.target.value)}
//                   />
//                 </div>

//                 {otpStatus && (
//                   <div>
//                     <label>Enter OTP: </label>
//                     <input
//                       type="text"
//                       value={otp}
//                       onChange={(e) => setOtp(e.target.value)}
//                     />
//                   </div>
//                 )}
//                 <br />
//                 <button
//                   type="button"
//                   className="btnss btn-primarys login-button"
//                   onClick={otpStatus ? handleVerifyOtp : handleLogin}
//                 >
//                   {otpStatus ? "Verify OTP" : "Login"}
//                 </button>
//                 <div className="mt-3" style={{ fontSize: "18px" }}>
//                   Not registered? <Link to="/Register">Register now</Link>
//                   <br />
//                   <div className="mt-3" style={{ marginLeft: "20px" }}>
//                     <Link to="/forgot-password">Forgot Password?</Link>
//                   </div>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LoginPage;

// import React, { useState } from "react";
// import axios from "axios";
// import Navbar from "../components/Navbar";
// import Header from "../components/Header";
// import "./LoginPage.css";
// import { Link, useNavigate } from "react-router-dom";

// const LoginPage = () => {
//   const [otpStatus, setOtpStatus] = useState(false);
//   const [otp, setOtp] = useState("");
//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");
//   const [mobilenumber, setMobilenumber] = useState("");

//   // let host = "https://api.vmrdarental.com";
//   let host = "https://api.vmrdarental.com";

//   const navigate = useNavigate();

//   const handleLogin = async () => {
//     if (!mobilenumber === "") {
//       alert("Please Enter Username and password");
//     } else {
//       try {
//         const response = await axios.post(host + "/loginuser", {
//           mobile_number: mobilenumber,
//         });

//         console.log("API Response:", response);
//         console.log("API Data:", response.data);

//         if (response.status === 200 && response.data.status === 200) {
//           const userData = {
//             mobilenumber,
//             name: response.data.data[0].name, // Store the user's name
//           };
//           localStorage.setItem("token-info", JSON.stringify(userData));
//           localStorage.setItem("userRole", response.data.data[0].user_type);
//           localStorage.setItem(
//             "access_token",
//             response.data.data[0].access_token
//           );
//           let bookingDetailsData = JSON.parse(
//             localStorage.getItem("selectedRoomData")
//           );

//           // If the user type is 0 (regular user), check for booking details
//           if (response.data.data[0].user_type === 0) {
//             // Check if bookingDetailsData exists and has selectedRooms
//             if (
//               !bookingDetailsData || // If bookingDetailsData is undefined
//               !bookingDetailsData.selectedRooms || // or selectedRooms is null or undefined
//               bookingDetailsData.selectedRooms.length === 0 // or selectedRooms array is empty
//             ) {
//               navigate("/", "_self");
//             } else {
//               navigate("/", "_self");
//             }
//           } else {
//             console.log("Admin OTP Required");
//             try {
//               const respOtpStatus = await axios.post(host + "/userotplogin", {
//                 mobile_number: response.data.data[0].mobile_number,
//               });
//               if (respOtpStatus.data.status === 200) {
//                 setOtpStatus(true);
//                 console.log(otpStatus, "otpStatus true");
//               }
//             } catch (error) {
//               console.error("Login failed:", error.message);
//             }
//           }
//         } else {
//           alert("Invalid password or user not found");
//         }
//         console.log("Login attempt completed");
//       } catch (error) {
//         console.error("Login failed:", error.message);
//       }
//     }
//   };

//   const handleVerifyOtp = async () => {
//     try {
//       const otpVerifyResponse = await axios.post(host + "/userverifyotp", {
//         otp,
//         mobile_number: mobilenumber, // Adjust this accordingly based on your backend
//       });

//       if (otpVerifyResponse.data.status === 200) {
//         alert("OTP Verified Successfully");

//         // Continue with the login process
//         const response = await axios.post(host + "/loginuser", {
//           mobilenumber,
//         });

//         if (response.status === 200 && response.data.status === 200) {
//           const userData = {
//             mobilenumber,
//             name: response.data.data[0].name,
//           };

//           localStorage.setItem("token-info", JSON.stringify(userData));
//           localStorage.setItem("userRole", response.data.data[0].user_type);
//           localStorage.setItem(
//             "access_token",
//             response.data.data[0].access_token
//           );

//           let bookingDetailsData = JSON.parse(
//             localStorage.getItem("bookingDetailsData")
//           );

//           // Check if bookingDetailsData exists and has selectedRooms
//           if (
//             !bookingDetailsData || // If bookingDetailsData is undefined
//             !bookingDetailsData.selectedRooms || // or selectedRooms is null or undefined
//             bookingDetailsData.selectedRooms.length === 0 // or selectedRooms array is empty
//           ) {
//             navigate("/", "_self");
//           } else {
//             navigate("/previewpage", "_self");
//           }
//         } else {
//           alert("Invalid password or user not found");
//         }
//       } else {
//         alert("Failed to verify OTP");
//       }
//     } catch (otpVerifyError) {
//       console.error("Error verifying OTP:", otpVerifyError.message);
//     }
//   };

//   return (
//     <div>
//       <Header />

//       <div className="container">
//         <div className="row justify-content-center">
//           <div className="col-lg-10 col-md-10 col-sm-10 col-xs-10">
//             <div className="container mt-2">
//               <form className="login-form">
//                 <h1
//                   className="text-center"
//                   style={{ fontSize: "25px", color: "green" }}
//                 >
//                   Login
//                 </h1>
//                 <div className="mb-3">
//                   <label>Mobile Number: </label>
//                   <input
//                     type="text"
//                     value={mobilenumber}
//                     onChange={(e) => setMobilenumber(e.target.value)}
//                   />
//                 </div>

//                 {otpStatus && (
//                   <div>
//                     <label>Enter OTP: </label>
//                     <input
//                       type="text"
//                       value={otp}
//                       onChange={(e) => setOtp(e.target.value)}
//                     />
//                   </div>
//                 )}
//                 <br />
//                 <button
//                   type="button"
//                   className="btnss btn-primarys login-button"
//                   onClick={otpStatus ? handleVerifyOtp : handleLogin}
//                 >
//                   {otpStatus ? "Verify OTP" : "Login"}
//                 </button>
//                 <div className="mt-3" style={{ fontSize: "18px" }}>
//                   Not registered? <Link to="/Register">Register now</Link>
//                   <br />
//                   <div className="mt-3" style={{ marginLeft: "20px" }}>
//                     <Link to="/forgot-password">Forgot Password?</Link>
//                   </div>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LoginPage;

import React, { useState } from "react";
import axios from "axios";
import Navbar from "../components/Navbar";
import Header from "../components/Header";
import "./LoginPage.css";
import { Link, useNavigate } from "react-router-dom";
import host from "../config";
const LoginPage = () => {
  const [otpStatus, setOtpStatus] = useState(false);
  const [otp, setOtp] = useState("");
  const [mobilenumber, setMobilenumber] = useState("");

  // let host = "https://api.vmrdarental.com";
  const navigate = useNavigate();

  const handleLogin = async () => {
    if (!mobilenumber) {
      alert("Please enter your mobile number");
      return;
    }

    try {
      // Step 1: Send OTP for all users
      const otpResponse = await axios.post(host + "/userotplogin", {
        mobile_number: mobilenumber,
      });

      if (otpResponse.data.status === 200) {
        setOtpStatus(true);
        console.log("OTP Sent Successfully");
      } else {
        alert("Failed to send OTP");
      }
    } catch (error) {
      console.error("OTP Sending Failed:", error.message);
    }
  };

  // ✅ Handle OTP Verification and Login
  const handleVerifyOtp = async () => {
    if (!otp) {
      alert("Please enter OTP");
      return;
    }

    try {
      const otpVerifyResponse = await axios.post(host + "/userverifyotp", {
        otp,
        mobile_number: mobilenumber,
      });

      if (otpVerifyResponse.data.status === 200) {
        alert("OTP Verified Successfully");

        // Step 2: Login after OTP Verification
        const response = await axios.post(host + "/loginuser", {
          mobile_number: mobilenumber,
        });

        if (response.status === 200 && response.data.status === 200) {
          const userData = {
            mobilenumber,
            name: response.data.data[0].name,
          };

          localStorage.setItem("token-info", JSON.stringify(userData));
          localStorage.setItem("userRole", response.data.data[0].user_type);
          localStorage.setItem(
            "access_token",
            response.data.data[0].access_token
          );

          let bookingDetailsData = JSON.parse(
            localStorage.getItem("bookingDetailsData")
          );

          if (
            !bookingDetailsData ||
            !bookingDetailsData.selectedRooms ||
            bookingDetailsData.selectedRooms.length === 0
          ) {
            navigate("/", "_self");
          } else {
            navigate("/previewpage", "_self");
          }
        } else {
          alert("Invalid user or login failed");
        }
      } else {
        alert("Failed to verify OTP");
      }
    } catch (error) {
      console.error("OTP Verification Failed:", error.message);
    }
  };

  return (
    <div>
      <Header />
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10 col-md-10 col-sm-10 col-xs-10">
            <div className="container mt-2">
              <form className="login-form">
                <h1
                  className="text-center"
                  style={{ fontSize: "25px", color: "green" }}
                >
                  Login
                </h1>
                <div className="mb-3">
                  <label>Mobile Number: </label>
                  <input
                    type="text"
                    value={mobilenumber}
                    onChange={(e) => setMobilenumber(e.target.value)}
                  />
                </div>

                {otpStatus && (
                  <div>
                    <label>Enter OTP: </label>
                    <input
                      type="text"
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                    />
                  </div>
                )}
                <br />
                <button
                  type="button"
                  className="btnss btn-primarys login-button"
                  onClick={otpStatus ? handleVerifyOtp : handleLogin}
                >
                  {otpStatus ? "Verify OTP" : "Send OTP"}
                </button>
                <div className="mt-3" style={{ fontSize: "18px" }}>
                  Not registered? <Link to="/Register">Register now</Link>
                  <br />
                  <div className="mt-3" style={{ marginLeft: "20px" }}>
                    <Link to="/forgot-password">Forgot Password?</Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
